// Shared color system for calendar events and time-block types.
// Users pick from a curated preset palette; colors are saved in settings.block_colors
// as { cal: { <calendarId>: hex }, cat: { <categoryKey>: hex } }.

export const PRESET_COLORS = [
  '#f5643c', // coral (brand)
  '#f5a214', // amber
  '#eab308', // gold
  '#22c55e', // green
  '#14b8a6', // teal
  '#0ea5e9', // sky
  '#3b6fe0', // blue
  '#6366f1', // indigo
  '#8b5cf6', // purple
  '#a855f7', // violet
  '#d946ef', // magenta
  '#ec4899', // pink
  '#f43f5e', // rose
  '#64748b', // slate
];

export const CAT_DEFS = [
  { key: 'deep_work', label: 'Deep work', color: '#14b8a6' },
  { key: 'meeting', label: 'Meeting', color: '#f5a214' },
  { key: 'admin', label: 'Admin', color: '#f5643c' },
  { key: 'break', label: 'Break', color: '#64748b' },
  { key: 'personal', label: 'Personal', color: '#f43f5e' },
];

export const CAT_LABEL = Object.fromEntries(CAT_DEFS.map((c) => [c.key, c.label]));
export const CAT_COLOR = Object.fromEntries(CAT_DEFS.map((c) => [c.key, c.color]));

// hex (#rrggbb) -> #rrggbbaa translucent tint for block backgrounds.
export function hexTint(hex, alpha = 0.14) {
  if (!hex || hex[0] !== '#' || hex.length < 7) return 'transparent';
  const a = Math.round(Math.max(0, Math.min(1, alpha)) * 255).toString(16).padStart(2, '0');
  return `${hex.slice(0, 7)}${a}`;
}

// Resolve bar + tint for a block. Calendar color wins for synced events,
// then the block-type (category) color, then the built-in default.
// In dark mode we raise the tint alpha so colors read clearly on a dark surface.
export function blockStyle(block, colors, isDark = false) {
  const cal = (colors && colors.cal) || {};
  const cat = (colors && colors.cat) || {};
  let hex = null;
  if (block && block.calendar_id && cal[block.calendar_id]) hex = cal[block.calendar_id];
  else if (block && block.category && cat[block.category]) hex = cat[block.category];
  else hex = CAT_COLOR[block && block.category] || CAT_COLOR.admin;
  return { bar: hex, tint: hexTint(hex, isDark ? 0.30 : 0.14), color: hex };
}
